import React, { useMemo, useState } from 'react';
import { MDBCol, MDBRow } from 'mdb-react-ui-kit';
import Select from 'react-select';
import Swal from 'sweetalert2';

const FormModalCreateBeacons = ({ onSave, initialData, proyectos }) => {
    const [deviceID, setDeviceID] = useState(initialData?.DeviceID || '');
    const [fkLokProyecto, setFkLokProyecto] = useState(
        initialData?.fkLokProyecto != null ? String(initialData.fkLokProyecto) : ''
    );
    const projectOptions = useMemo(
        () => proyectos.map((proyecto) => ({
            value: String(proyecto.IDProyecto),
            label: proyecto.Descripcion,
        })),
        [proyectos]
    );
    const selectedProject = useMemo(
        () => projectOptions.find((option) => option.value === fkLokProyecto) || null,
        [fkLokProyecto, projectOptions]
    );

    const projectSelectStyles = useMemo(
        () => ({
            control: (provided, state) => ({
                ...provided,
                minHeight: 38,
                borderColor: state.isFocused ? '#86b7fe' : '#ced4da',
                boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(13, 110, 253, 0.25)' : 'none',
                '&:hover': {
                    borderColor: state.isFocused ? '#86b7fe' : '#ced4da',
                },
            }),
            menuPortal: (provided) => ({
                ...provided,
                zIndex: 9999,
            }),
            menu: (provided) => ({
                ...provided,
                zIndex: 9999,
            }),
        }),
        []
    );

    const submit = event => {
        event.preventDefault();

        if (!deviceID.trim() || !fkLokProyecto) {
            Swal.fire('Error', 'Debe completar todos los campos', 'error');
            return;
        }

        onSave({ DeviceID: deviceID, fkLokProyecto });
    };

    return (
        <form onSubmit={submit}>
            <MDBRow className="mb-3 g-0">
                <MDBCol size="12">
                    <label className="form-label" htmlFor="beacon-device-id">Device ID</label>
                    <input
                        id="beacon-device-id"
                        type="text"
                        className="form-control"
                        placeholder="Ingrese Device ID"
                        value={deviceID}
                        maxLength={50}
                        onChange={event => setDeviceID(event.target.value)}
                        disabled={initialData?.isEditing}
                        style={{ boxSizing: 'border-box' }}
                    />
                </MDBCol>
            </MDBRow>

            <MDBRow className="mb-3 g-0">
                <MDBCol size="12">
                    <label className="form-label" htmlFor="beacon-project">Proyecto</label>
                    <Select
                        inputId="beacon-project"
                        classNamePrefix="beacon-project-select"
                        options={projectOptions}
                        value={selectedProject}
                        onChange={option => setFkLokProyecto(option?.value || '')}
                        placeholder="Seleccione un proyecto"
                        noOptionsMessage={() => 'Sin coincidencias'}
                        isClearable
                        isSearchable
                        styles={projectSelectStyles}
                        menuPortalTarget={typeof document !== 'undefined' ? document.body : undefined}
                        menuPosition="fixed"
                    />
                </MDBCol>
            </MDBRow>

            <div className="d-flex justify-content-end">
                <button type="submit" className="btn-primary-modals-maestros">
                    {initialData?.isEditing ? 'Actualizar' : 'Guardar'}
                </button>
            </div>
        </form>
    );
};

export default FormModalCreateBeacons;
